const { renderToString } = wp.element;

import { 
  Tag,
  GlobeAsiaAustralia,
  GlobeAmericas,
  LightBulb,
  GlobeAlt,
  Fire,
  AdjustmentsHorizontal,
  Identification,
  FingerPrint,
  CogSixTooth,
  Camera,
  Calculator,
  CalendarDays,
  BuildingLibrary,
  Bolt,
  AcademicCap,
  Sparkles,
  RocketLaunch,
  NoSymbol,
  BuildingOfficeTwo,
  ClipboardDocument,
  CurrencyDollar,
  ExclamationTriangle,
  HandRaised,
  Keys,
  Users,
  User,
  Wallet,
  HomeModern,
  Home,
  Scale,
  Banknotes,
  ChatBubbleLeft,
} from '../theme/assets/block-icons/HeroSmall.js';

const svgToString = (svgComponent) => renderToString(svgComponent);

// Ensure icons array is defined outside of the component
const icons = [
  {name: "none", svg: <NoSymbol />, svgString: ''},
  {name: "Tag", svg: <Tag />, svgString: svgToString(<Tag />)},
  {name: "GlobeAsiaAustralia", svg: <GlobeAsiaAustralia />, svgString: svgToString(<GlobeAsiaAustralia />)},
  {name: "GlobeAmericas", svg: <GlobeAmericas />, svgString: svgToString(<GlobeAmericas />)},
  {name: "Lightbulb", svg: <LightBulb />, svgString: svgToString(<LightBulb />)},
  {name: "GlobeAlt", svg: <GlobeAlt />, svgString: svgToString(<GlobeAlt />)},
  {name: "Fire", svg: <Fire />, svgString: svgToString(<Fire />)},
  {name: "AdjustmentsHorizontal", svg: <AdjustmentsHorizontal />, svgString: svgToString(<AdjustmentsHorizontal />)},
  {name: "Identification", svg: <Identification />, svgString: svgToString(<Identification />)},
  {name: "FingerPrint", svg: <FingerPrint />, svgString: svgToString(<FingerPrint />)},
  {name: "CogSixTooth", svg: <CogSixTooth />, svgString: svgToString(<CogSixTooth />)},
  {name: "Camera", svg: <Camera />, svgString: svgToString(<Camera />)},
  {name: "Calculator", svg: <Calculator />, svgString: svgToString(<Calculator />)},
  {name: "CalendarDays", svg: <CalendarDays />, svgString: svgToString(<CalendarDays />)},
  {name: "BuildingLibrary", svg: <BuildingLibrary />, svgString: svgToString(<BuildingLibrary />)},
  {name: "Bolt", svg: <Bolt />, svgString: svgToString(<Bolt />)},
  {name: "AcademicCap", svg: <AcademicCap />, svgString: svgToString(<AcademicCap />)},
  {name: "Sparkles", svg: <Sparkles />, svgString: svgToString(<Sparkles />)},
  {name: "RocketLaunch", svg: <RocketLaunch />, svgString: svgToString(<RocketLaunch />)},
  {name: "BuildingOfficeTwo", svg: <BuildingOfficeTwo />, svgString: svgToString(<BuildingOfficeTwo />)},
  {name: "ClipboardDocument", svg: <ClipboardDocument />, svgString: svgToString(<ClipboardDocument />)},
  {name: "CurrencyDollar", svg: <CurrencyDollar />, svgString: svgToString(<CurrencyDollar />)},
  {name: "ExclamationTriangle", svg: <ExclamationTriangle />, svgString: svgToString(<ExclamationTriangle />)},
  {name: "HandRaised", svg: <HandRaised />, svgString: svgToString(<HandRaised />)},
  {name: "Keys", svg: <Keys />, svgString: svgToString(<Keys />)},
  {name: "Users", svg: <Users />, svgString: svgToString(<Users />)},
  {name: "User", svg: <User />, svgString: svgToString(<User />)},
  {name: "Wallet", svg: <Wallet />, svgString: svgToString(<Wallet />)},
  {name: "HomeModern", svg: <HomeModern />, svgString: svgToString(<HomeModern />)},
  {name: "Home", svg: <Home />, svgString: svgToString(<Home />)},
  {name: "Scale", svg: <Scale />, svgString: svgToString(<Scale />)},
  {name: "Banknotes", svg: <Banknotes />, svgString: svgToString(<Banknotes />)},
  {name: "ChatBubbleLeft", svg: <ChatBubbleLeft />, svgString: svgToString(<ChatBubbleLeft />)},
];

// Ensure IconSelectSquare is a pure functional component
const IconSelectSquare = ({ icon, onClick, isSelected }) => (
  <div 
    onClick={() => onClick(icon)}
    style={{
      border: isSelected ? '2px solid blue' : '2px solid #e1e1e1',
      cursor: 'pointer',
      display: 'inline-flex', 
      width: "24px", 
      height: "24px"
    }}
  >
    {icon.svg}
  </div>
);

export const IconSelectBox = ({ currentIcon = {name: "none", svg: null, svgString: ''}, onSelectIcon = () => {} }) => {
  const validIcon = currentIcon && currentIcon.name ? currentIcon : {name: "none", svg: null, svgString: ''};

  return (
    <div style={{ display: "flex", flexWrap: "wrap", boxShadow: "4px 4px 8px rgba(0,0,0,.16)", maxWidth: "280px", backgroundColor:"#e1e1e1" }}>
      {icons.map((icon, index) => (
        <IconSelectSquare
          key={index}
          icon={icon}
          onClick={() => onSelectIcon({ name: icon.name })} // rendered from iconMap by name; older tabs also carry an svg string
          isSelected={icon.name === validIcon.name}
        />
      ))}
    </div>
  );
};